import { Injectable } from '@angular/core'
import { RoutePathEnum } from '@shared/enums'
import { AccountService } from '../../services/account.service'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { RouteManagerService } from '@shared/services'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private _accountService: AccountService,
    private _router: Router,
    private _routeManagerService: RouteManagerService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if ((route as any)._routerState.url.startsWith(`/${RoutePathEnum.THIRD_PARTY_AUTH}`)) {
      const urlSegments = (route as any)._routerState.url.split('/')

      if (urlSegments.length === 7) {
        return true
      }
    }

    if ((route as any)._routerState.url.startsWith('/error')) {
      return true
    }

    if (!this._accountService.authenticated || (route as any)._routerState.url === '/') {
      this._router.navigate(['/login'])
    }

    return true
  }
}
